import { z } from 'zod/v3';
import {
  SimplifiedElementSchema,
  QualityThresholdsSchema,
  SubtaskDefinitionSchema,
  TemplateExecutionConfigSchema,
} from './guided-template.dto';
import { TemplateSamplingConfigSchema } from './population.dto';
import { TemplateTypeSchema } from '../generated/enums';

export const GuidedTemplateImportMetadataSchema = z.object({
  sourceFile: z.string().optional(),
  convertedAt: z.string().optional(),
  stats: z.object({
    total: z.number(),
    success: z.number(),
    failed: z.number(),
    durationMs: z.number(),
  }).optional(),
});

export type GuidedTemplateImportMetadata = z.infer<typeof GuidedTemplateImportMetadataSchema>;

export const GuidedTemplateImportTemplateSchema = z.object({
  controlId: z.string(),
  trustIds: z.array(z.string()).nonempty(),
  title: z.string(),
  description: z.string().optional(),
  templateType: TemplateTypeSchema,
  instructions: z.string().optional(),
  executionConfig: TemplateExecutionConfigSchema.nullable().optional(),
  targetUrl: z.string().optional(),
  requiredElements: z.array(SimplifiedElementSchema),
  qualityThresholds: QualityThresholdsSchema,
  samplingConfig: TemplateSamplingConfigSchema.nullable().optional(),
  suggestedFrequency: z.enum(['ONCE', 'MONTHLY', 'QUARTERLY', 'SEMI_ANNUAL', 'ANNUAL']).optional(),
  subtasks: z.array(SubtaskDefinitionSchema).optional().nullable(),
});

export type GuidedTemplateImportTemplate = z.infer<typeof GuidedTemplateImportTemplateSchema>;

export const GuidedTemplateImportFileSchema = z.object({
  metadata: GuidedTemplateImportMetadataSchema.optional(),
  templates: z.array(GuidedTemplateImportTemplateSchema),
  errors: z.array(z.object({ controlId: z.string(), error: z.string() })).optional(),
});

export type GuidedTemplateImportFile = z.infer<typeof GuidedTemplateImportFileSchema>;

export const GuidedTemplateImportRequestSchema = z.object({
  frameworkId: z.string(),
  json: z.string(),
  templatesOnly: z.boolean().default(false).optional(),
  dryRun: z.boolean().default(false).optional(),
  clean: z.boolean().default(false).optional(),
});

export type GuidedTemplateImportRequest = z.infer<typeof GuidedTemplateImportRequestSchema>;

export const GuidedTemplateImportResultSchema = z.object({
  created: z.number(),
  updated: z.number(),
  skipped: z.number(),
  errors: z.array(z.string()),
  total: z.number(),
  metadata: GuidedTemplateImportMetadataSchema.optional(),
});

export type GuidedTemplateImportResult = z.infer<typeof GuidedTemplateImportResultSchema>;
